import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  ElementRef,
  inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AbstractControl, FormArray, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ValidatorService } from 'src/app/shared/services/form-control-validators.service';
import {
  clearanceChargesFormConfig,
  customerServiceFormConfig,
  customerServiceTableColumnConfig,
  defaultCustomerServiceData,
  deliveryFeesFormConfig,
  getGovernmentServiceTypesTbdValue,
  getSavedCustomerServiceCount,
  GOVERNMENT_INFO_TBD_DISPLAY,
  governmentInformationFields,
  isGovernmentServiceTypeTbd,
  iscFormConfig,
  masterShipmentBillingList,
  recoveryFeesFormConfig,
  reimbursableChargesFormConfig,
} from '../../accounts.config';
import {
  FormField,
  IDropdownResponse,
  ILookupDropdownResponse,
  SvgIcon,
  SvgIconProp,
} from 'src/app/shared/models/dynamic.model';
import {
  ActionIcons,
  actionText,
  BulkDeleteItemNames,
  conditionCheckConstants,
  DataTypes,
  formFieldTypes,
  MasterLookup,
  ModalPopupMessages,
  ModeIcons,
  pageType,
  popupWidth,
  selectedIdForSummaryTable,
  selectionTableNames,
  SingleDeleteHeaderText,
  StatusCodes,
  validationErrorMessages,
  gridMessages,
} from 'src/app/shared/utility/constants';
import {
  DefaultInfoHeaderIcons,
  DefaultInfoTableHeaderIcons,
  masterShipmentBillingIcons,
} from 'src/app/shared/utility/svg-constants';
import { ModalService } from 'src/app/shared/services/modal.service';
import { MessagePopupComponent } from 'src/app/shared/components/message-popup/message-popup.component';
import { SnakbarService } from 'src/app/shared/services/snakbar.service';
import { CommonService } from 'src/app/shared/services/common.service';

import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { map, Observable, startWith } from 'rxjs';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Store } from '@ngxs/store';
import { SaveGovernmentDetails } from '../../store/accounts.action';
import {
  ICustomerService,
  IGovernmentInfoDetailsData,
} from 'src/app/features/model/sm-accounts';
import { AccountsService } from 'src/app/features/service/accounts.service';
import { AddInlineEditTableComponent } from 'src/app/shared/components/tables/add-inline-edit-table/add-inline-edit-table.component';
import { ValidatorPattern } from 'src/app/shared/utility/validators.pattern';
import { IBCAuthService } from 'src/app/features/service/auth.service';
import { MasterShipmentBillingCardModel } from 'src/app/features/model/account.model';

@Component({
  selector: 'app-government-information',
  templateUrl: './government-information.component.html',
  styleUrl: './government-information.component.scss',
})
export class GovernmentInformationComponent
  implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('emailInput') emailInput!: ElementRef;
  @ViewChild('emailInput2') emailInput2!: ElementRef;
  @ViewChild('serviceTypeSearchInput')
  serviceTypeSearchInput!: ElementRef<HTMLInputElement>;
  @ViewChild(AddInlineEditTableComponent)
  private readonly addInlineEditTableComp!: AddInlineEditTableComponent;

  public accountGovtInfoForm!: FormGroup;
  public formFields!: FormField[];
  public errorMessages: any;
  public formFieldType = formFieldTypes;
  public actionIcons = ActionIcons;
  public customerServiceTableColumnConfig = customerServiceTableColumnConfig;
  public customerServiceFormConfig = customerServiceFormConfig;
  public tableName = selectionTableNames;
  public headerText = SingleDeleteHeaderText;
  public customerServiceTableHeaderIcons!: SvgIconProp[];
  public customerServiceSelectedRow!: any;
  public setGovernmentInfoWidth: any = {};
  public setGovernmentInfoErrorTooltip: any = {};
  public setGovernmentInfoTooltipEvent: any = {};
  public governmentInfoTabData$!: Observable<IGovernmentInfoDetailsData>;
  public governmentInfoTabFormData: any;
  public pageMode!: string;
  public customerServiceGridFormData: any;
  public customerServiceGridForm!: FormGroup;
  public readonly governmentInfoTbdDisplay = GOVERNMENT_INFO_TBD_DISPLAY;
  public readonly governmentInfoServiceTypesTbdValue =
    getGovernmentServiceTypesTbdValue();
  public emailCtrl = new FormControl(
    '',
    Validators.pattern(ValidatorPattern.Email_Validator)
  );
  public emailCtrl2 = new FormControl(
    '',
    Validators.pattern(ValidatorPattern.Email_Validator)
  );
  public emailsForInvoiceNotifications: any = [];
  public emailsForGatewayNotifications: any = [];
  public billingTypeData!: IDropdownResponse[];
  public userInvoiceEmailData!: IDropdownResponse[];
  public filterUserInvoiceEmailData!: Observable<any[]>;
  public userGatewayEmailData!: IDropdownResponse[];
  public filterUserGatewayEmailData!: Observable<any[]>;
  public salesPersonData!: IDropdownResponse[];
  public filterSalesPersonOption!: Observable<any[]>;
  deliveryAgentData!: IDropdownResponse[];
  public filteredDeliveryAgentsList!: Observable<any[]>;
  public ModeIcons = ModeIcons;
  public popupMessages = ModalPopupMessages;
  public isEditClicked = false;
  public isAddClicked = false;
  public form!: FormGroup;
  public recoveryForm!: FormGroup;
  public reimbursableChargesForm!: FormGroup;
  public iscForm!: FormGroup;
  public delivertyFeesForm!: FormGroup;
  public clearanceChargesForm!: FormGroup;
  public masterShipmentBillingTile: MasterShipmentBillingCardModel[] =
    masterShipmentBillingList;
  public masterShipmentIcons = JSON.parse(
    JSON.stringify(masterShipmentBillingIcons)
  );
  private readonly destroyRef = inject(DestroyRef);
  private deletedCustomerServicesList!: any;

  // variables for chip autocomplete
  public visible = true;
  public selectable = true;
  public removable = true;
  public addOnBlur = false;
  public emailErrorMessage = validationErrorMessages.invalidEmailEntered;
  separatorKeysCodes = [ENTER, COMMA];
  public invoiceTypeDropdownValues!: IDropdownResponse[];
  public invoiceTypeLookupData: IDropdownResponse[] = [];
  public weightMetricDropdownValues!: IDropdownResponse[];
  public clearanceTypeDropdownValues: IDropdownResponse[] = [];
  public ibcChargeCodeDropdownValues!: IDropdownResponse[];
  public selectedFileFormatType = 10;
  public serviceTypeDropDownValues!: IDropdownResponse[];
  public serviceTypeSearchCtrl = new FormControl('');
  public serviceTypeSearchText = '';
  public noMatchingServiceTypes = gridMessages.noMatchingServiceTypes;
  public agentsDropDownValues!: IDropdownResponse[];
  public isAccountHasARInvoice = false;
  private originalBillingTypeValues: string[] = [];

  // Autocomplete filtered data observables
  private readonly autocompleteDataMap: Map<
    string,
    Observable<IDropdownResponse[]>
  > = new Map();

  // Map to store the selected IDs for autocomplete fields (for API payload)
  private readonly autocompleteSelectedIds: Map<string, number> = new Map();

  // Flag to track when lookup data is loaded
  private isLookupDataLoaded = false;
  private autocompleteBlurTimer: ReturnType<typeof setTimeout> | null = null;
  public isUfoCustomerServiceNotApplicable = false;

  get customerServiceGridPageMode(): string {
    if (
      this.pageMode === ModeIcons.view ||
      this.pageMode === ModeIcons.smallview
    ) {
      return ModeIcons.view;
    }
    return this.commonService.isUFOAccountRestrictedEdit.value
      ? ModeIcons.view
      : this.pageMode;
  }

  constructor(
    private readonly formUtilsService: ValidatorService,
    private readonly modalService: ModalService,
    private readonly snakbarService: SnakbarService,
    public readonly commonService: CommonService,
    private readonly store: Store,
    private readonly accountsService: AccountsService,
    private readonly cdr: ChangeDetectorRef,
    private readonly ibcAuthService: IBCAuthService
  ) {
    this.setReqInit();
    this.governmentInfoTabData$ = this.store.select(
      state => state.accountsGovernmentInfo
    );
  }

  ngOnInit() {
    this.checkMode();
    this.commonService.isUFOAccountRestrictedEdit
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.isUfoCustomerServiceNotApplicable =
          this.commonService.isUFOAccountRestrictedEdit.value;
        this.applyGovernmentUfoFieldLocks();
        this.refreshCustomerServiceHeaderIcons();
      });
    this.dataFetch();
    this.getDeletedCustomerServices();
  }

  ngAfterViewInit(): void {
    this.customerServiceGridForm =
      this.addInlineEditTableComp.inlineCrudTableForm;
    if (this.customerServiceGridPageMode !== ModeIcons.view) {
      this.resetFirstInputRow();
    }
    this.bindCustomerGridData();
    this.patchDataAfterBind();
    this.checkGovtInfoValidData();
  }

  ngOnDestroy(): void {
    if (this.autocompleteBlurTimer) {
      clearTimeout(this.autocompleteBlurTimer);
    }
    // Clear autocomplete selected IDs map
    this.autocompleteSelectedIds.clear();
  }

  private setReqInit() {
    this.createForm();
    this.formFields = governmentInformationFields.fields.filter(
      controls => controls.type !== conditionCheckConstants.extra
    );
    this.getIconsForCustomerServiceTableInfoMode(ModeIcons.add);
    this.loadLookUpData();
    this.createRecoveryForm();
    this.createReimbursableChargesForm();
    this.createIscForm();
    this.createDeliveryFeesForm();
    this.createClearanceChargesForm();
  }

  public onCustomerServiceTableSelectionChange(selectedRows: any[]) {
    this.customerServiceSelectedRow = selectedRows;
    this.customerServiceTableDataSelected(selectedRows.length > 0);
  }

  public onCustomerServiceFormFieldChange(formData: any) {
    if (this.isUfoCustomerServiceNotApplicable) {
      return;
    }
    this.customerServiceGridFormData = formData;
    const editableRows =
      this.getCustomerGridFormRows()?.controls.filter(control => control.enabled) ||
      [];
    const isSaveEnabled =
      editableRows.length > 0 &&
      editableRows.every(control => control.valid);
    const modifiedIcons = this.customerServiceTableHeaderIcons.map(
      (val: SvgIconProp) => {
        if (val.name === ActionIcons.save) {
          val.isDisabled = !isSaveEnabled;
        } else if (val.name === ActionIcons.close) {
          val.isDisabled = false;
        } else {
          val.isDisabled = true;
        }
        return val;
      }
    );
    this.customerServiceTableHeaderIcons = modifiedIcons;
  }

  public onCustomerServiceIconClicked(iconClicked: SvgIcon) {
    if (this.isUfoCustomerServiceNotApplicable) {
      return;
    }
    if (iconClicked.name === ActionIcons.add) {
      this.handleCustomerGridAdd();
    } else if (iconClicked.name === ActionIcons.save) {
      this.handleCustomerGridSave();
    } else if (iconClicked.name === ActionIcons.close) {
      this.handleCustomerGridCancel();
    } else if (iconClicked.name === ActionIcons.delete) {
      if (
        this.getCustomerGridFormRows().length ===
        this.customerServiceSelectedRow.length &&
        this.customerServiceGridPageMode == ModeIcons.view
      ) {
        this.modalService.openPopup(
          {
            message: validationErrorMessages.customerServiceDelete,
            isFooterRequired: false,
          },
          ModalPopupMessages.Warning,
          MessagePopupComponent,
          popupWidth.deletePopup
        );
      } else {
        this.handleCustomerGridDelete();
      }
    } else if (iconClicked.name === ActionIcons.edit) {
      this.handleCustomerGridEdit();
    }
  }

  public checkControlForError(controlName: string) {
    return this.commonService.checkControlError(
      this.accountGovtInfoForm,
      controlName
    );
  }

  public fetchWidth(event: MouseEvent, controlName: string) {
    this.commonService.setErrorTooltipData(
      event,
      controlName,
      this.setGovernmentInfoWidth,
      this.setGovernmentInfoTooltipEvent,
      this.setGovernmentInfoErrorTooltip
    );
    event.stopPropagation();
    event.preventDefault();
  }

  public fetchErrorMessages(controlName: string): string {
    if (
      this.accountGovtInfoForm.get(controlName)?.errors?.['autocompleteError']
    ) {
      return validationErrorMessages.autocompleteError;
    } else {
      return this.formUtilsService.getErrorMessage(
        this.accountGovtInfoForm,
        this.errorMessages,
        controlName
      );
    }
  }

  public dispatchBusinessFormChanges() {
    this.dataForDispatch(
      this.addInlineEditTableComp.inlineCrudTableDataSource.data
    );
    this.commonService.checkPristineAccordionData(false);
    this.validateGovernmentInfoTab();
  }

  // Method to check if master billing container should be shown
  public isMasterBillingVisible(): boolean {
    const billingTypeValue = this.accountGovtInfoForm.get('billingType')?.value;
    return Array.isArray(billingTypeValue) && billingTypeValue.includes('1');
  }

  private dataForDispatch(customerServiceData: ICustomerService[]) {
    const masterShipmentBilling = this.createMasterShipmentBillingPayload();

    const govtInfoData = {
      ...this.accountGovtInfoForm.getRawValue(),
      invoiceFileFormat: Number(
        this.accountGovtInfoForm.get('invoiceFileFormat')?.value
      ),
      invoiceType: this.accountGovtInfoForm.get('invoiceType')?.value
        ? Number(this.accountGovtInfoForm.get('invoiceType')?.value)
        : null,
      billingType: this.accountGovtInfoForm
        .get('billingType')
        ?.value?.map((item: string) => Number(item)),
      serviceTypes: this.resolveServiceTypesForDispatch(),
      deliveryAgentId: this.resolveDeliveryAgentIdForDispatch(),
      customerService: customerServiceData,
      masterShipmentBilling: masterShipmentBilling,
      isAccountHasARInvoice: this.isAccountHasARInvoice,
      originalBillingType: this.originalBillingTypeValues.map(Number),
    };
    this.store.dispatch(new SaveGovernmentDetails(govtInfoData));
  }

  private createMasterShipmentBillingPayload() {
    const payload = {
      recoveryAmount: this.recoveryForm.get('recoveryAmount')?.value,
      recoveryWeightMetric:
        Number(this.recoveryForm.get('recoveryWeightMetric')?.value) || null,
      recoveryIbcChargeCode:
        this.getAutocompleteIdValue('recoveryIbcChargeCode') || null,
      deliveryAmount: this.delivertyFeesForm.get('deliveryAmount')?.value,
      deliveryWeightMetric:
        Number(this.delivertyFeesForm.get('deliveryWeightMetric')?.value) ||
        null,
      deliveryIbcChargeCode:
        this.getAutocompleteIdValue('deliveryIbcChargeCode') || null,
      reimbursableChargesValuePerShipment: this.reimbursableChargesForm.get(
        'reimbursableChargesValuePerShipment'
      )?.value,
      reimbursableChargesIbcChargeCode:
        this.getAutocompleteIdValue('reimbursableChargesIbcChargeCode') || null,
      clearanceChargesValuePerShipment: this.clearanceChargesForm.get(
        'clearanceChargesValuePerShipment'
      )?.value,
      clearanceChargesIbcChargeCode:
        this.getAutocompleteIdValue('clearanceChargesIbcChargeCode') || null,
      iscActualCost: this.iscForm.get('iscActualCost')?.value,
      iscFlatFee: this.iscForm.get('iscFlatFee')?.value,
      iscIbcChargeCode: this.getAutocompleteIdValue('iscIbcChargeCode') || null,
      reimbursableChargesClearanceType:
        this.getAutocompleteIdValue('reimbursableChargesClearanceType') || '',
      clearanceChargesClearanceType:
        this.getAutocompleteIdValue('clearanceChargesClearanceType') || '',
    };

    return payload;
  }

  private handleCustomerGridAdd() {
    this.isAddClicked = true;
    this.getIconsForAddIconClicked();
    this.clearAndPatchFormArray();
  }

  private getIconsForAddIconClicked() {
    const custServiceTableHeaderIcons = JSON.parse(
      JSON.stringify(DefaultInfoHeaderIcons)
    );
    const actionIconNames = [
      ActionIcons.add,
      ActionIcons.edit,
      ActionIcons.delete,
      ActionIcons.save,
      ActionIcons.close,
    ];
    this.customerServiceTableHeaderIcons = custServiceTableHeaderIcons
      .filter((val: SvgIconProp) => actionIconNames.includes(val.name))
      .map((val: SvgIconProp) => {
        val.isDisabled =
          val.name !== ActionIcons.close;
        return val;
      });
  }

  private handleCustomerGridSave() {
    if (this.customerServiceGridPageMode !== ModeIcons.view) {
      this.isEditClicked ? this.saveEditedData() : this.saveAddedData();
    } else if (this.customerServiceGridPageMode === ModeIcons.view) {
      const accountId = localStorage.getItem('accountId') ?? 0;
      let customerServiceData;
      if (!this.isAddClicked && this.isEditClicked) {
        customerServiceData = this.getCustomerGridFormRows().value;
      } else if (this.isAddClicked && !this.isEditClicked) {
        customerServiceData = [this.getCustomerGridFormRows().at(0).value];
        this.saveAddedData();
      }
      const payload = {
        accountId: +accountId,
        customerService: customerServiceData?.map((item: any) => ({
          ...item,
          deliveryAgentId:
            item.deliveryAgentId === '' ? null : item.deliveryAgentId,
          deliveryAgent: item.deliveryAgent === '' ? null : item.deliveryAgent,
          markUp: item.markUp === '' ? null : item.markUp,
        })),
      };
      this.saveOrUpdateCustomerServiceInViewMode(payload);
    }
  }

  private saveEditedData() {
    if (this.customerServiceGridForm.valid) {
      this.resetFirstInputRow();
      this.getCustomerGridFormRows().at(0).enable();
      this.updateRowsAfterEdit(false);
      this.addInlineEditTableComp.getTableData();
      this.dispatchBusinessFormChanges();
    }
  }

  private saveAddedData() {
    if (this.customerServiceGridForm.valid) {
      this.addInlineEditTableComp.addNewRow();
      const newRow = this.getCustomerGridFormRows().at(0).value;
      newRow.isRowDisable = true;
      newRow.tempId = this.commonService.generateUniqueTempId();
      this.getCustomerGridFormRows()
        .at(this.getCustomerGridFormRows().length - 1)
        .patchValue(newRow);
      this.addInlineEditTableComp.loadAutocompleteForNewRow(
        this.getCustomerGridFormRows().length - 1
      );
      this.getCustomerGridFormRows()
        .at(this.getCustomerGridFormRows().length - 1)
        .disable();
      this.resetFirstInputRow();
      this.dispatchBusinessFormChanges();
    } else {
      this.getCustomerGridFormRows().at(0).markAllAsTouched();
    }
  }

  private saveOrUpdateCustomerServiceInViewMode(payload: any) {
    this.accountsService
      .addorUpdateCustomerService(payload)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data: any) => {
          if (data.statusCode === StatusCodes.Success) {
            this.isAddClicked = false;
            this.isEditClicked = false;
            this.snakbarService.openCustomisedSnackBar(
              ModalPopupMessages.customerServiceAddUpdate(
                payload.customerService[0].id === 0
                  ? actionText.added
                  : actionText.update
              ),
              ModalPopupMessages.success
            );
            this.accountsService.setAccountFetchApi(true);
            this.clearAndPatchFormArray();
          } else if (data.statusCode === StatusCodes.SuccessfulRequest) {
            this.snakbarService.openCustomisedSnackBar(
              data.message,
              ModalPopupMessages.error
            );
          }
        },
      });
  }

  private handleCustomerGridCancel() {
    if (this.customerServiceGridPageMode === ModeIcons.view) {
      this.isAddClicked = false;
      this.isEditClicked = false;
      this.clearAndPatchFormArray();
      this.getIconsForCustomerServiceTableInfoMode(ModeIcons.view);
      this.snakbarService.openCustomisedSnackBar(
        ModalPopupMessages.actionCancel,
        ModalPopupMessages.success
      );
    } else {
      this.getCustomerGridFormRows().at(0).reset();
      this.getCustomerGridFormRows().at(0).enable();
      if (this.isEditClicked) {
        this.updateRowsAfterEdit(true);
      }
    }
  }

  private updateRowsAfterEdit(isForCancel: boolean) {
    this.getCustomerGridFormRows().controls.forEach((control, index) => {
      if (!control.get('isRowDisable')?.value && index !== 0) {
        if (isForCancel) {
          const modifiedRow =
            this.governmentInfoTabFormData.customerService.find(
              (data: ICustomerService) => data.tempId === control.value.tempId
            );
          this.getCustomerGridFormRows().at(index).patchValue(modifiedRow);
        }
        this.getCustomerGridFormRows()
          .at(index)
          .get('isRowDisable')
          ?.setValue(true);
        this.getCustomerGridFormRows().at(index).disable();
      }
    });
    this.isEditClicked = false;
  }

  private handleCustomerGridDelete() {
    let messageType;
    let message;
    if (this.customerServiceSelectedRow.length > 1) {
      message = ModalPopupMessages.bulkDeleteMessage(
        this.customerServiceSelectedRow.length,
        BulkDeleteItemNames.CustomerServices
      );
      messageType = ModalPopupMessages.BulkDeleteHeader;
    } else {
      const rateScale = this.customerServiceSelectedRow?.[0]?.rateScale;
      message =
        ModalPopupMessages.singleDeleteMessage(
          SingleDeleteHeaderText.CustomerService
        ) + (rateScale ? `record ${rateScale}?` : 'record?');
      messageType = ModalPopupMessages.singleDeleteHeader(
        SingleDeleteHeaderText.CustomerService
      );
    }
    const dialogRef = this.modalService.openPopup(
      {
        message: message,
        isMultiple: true,
        isFooterRequired: true,
        isBulk: this.customerServiceSelectedRow.length > 1,
      },
      messageType,
      MessagePopupComponent,
      popupWidth.deletePopup
    );
    dialogRef
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data) {
          this.customerServiceDelete();
        }
      });
  }

  private customerServiceDelete() {
    const selectedForDelete = [...this.customerServiceSelectedRow];
    selectedForDelete.forEach((customerService: any) => {
      const param =
        customerService.id === 0 ? selectedIdForSummaryTable.tempId : 'id';
      const rows = this.getCustomerGridFormRows();
      const indexToRemove: number[] = [];
      rows.controls.forEach((control, index) => {
        if (control.value[param] === customerService[param]) {
          indexToRemove.push(index);
        }
      });
      indexToRemove.forEach(index => {
        if (param === selectedIdForSummaryTable.Id) {
          rows.at(index).get('action')?.setValue(ActionIcons.delete);
          if (this.customerServiceGridPageMode !== ModeIcons.view) {
            this.accountsService.setDeletedCustomerServicesData(
              this.deletedCustomerServicesList.concat(rows.at(index).value)
            );
          }
        }
        rows.removeAt(index);
      });
      this.addInlineEditTableComp.getTableData();
      this.dispatchBusinessFormChanges();
    });
    if (this.customerServiceGridPageMode === ModeIcons.view) {
      this.deleteCustomerServiceInViewMode(selectedForDelete);
    } else {
      this.resetFirstInputRow();
      this.getIconsForCustomerServiceTableInfoMode(ModeIcons.add);
      this.addInlineEditTableComp.inlineTableSelection.clear();
    }
  }

  private deleteCustomerServiceInViewMode(selectedForDelete: any[]) {
    const deletedIds = selectedForDelete.map(
      (selectedData: any) => selectedData.id
    );
    this.accountsService
      .deleteCustomerService({
        ids: deletedIds,
        action: ActionIcons.delete,
      })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data: any) => {
          if (data.status === StatusCodes.Success) {
            this.snakbarService.openCustomisedSnackBar(
              ModalPopupMessages.customerServiceAddUpdate(actionText.deleted),
              ModalPopupMessages.success
            );
            this.addInlineEditTableComp.inlineTableSelection.clear();
            this.accountsService.setAccountFetchApi(true);
          }
        },
      });
  }

  private handleCustomerGridEdit() {
    this.isEditClicked = true;
    if (this.customerServiceGridPageMode !== ModeIcons.view) {
      this.getCustomerGridFormRows().at(0).reset();
      this.getCustomerGridFormRows().at(0).disable();
    }
    this.customerServiceSelectedRow.forEach((customerService: any) => {
      const param =
        customerService.id === 0 ? selectedIdForSummaryTable.tempId : 'id';
      this.getCustomerGridFormRows().controls.forEach((control, index) => {
        if (control.value[param] === customerService[param]) {
          this.getCustomerGridFormRows()
            .at(index)
            .get('isRowDisable')
            ?.setValue(false);
          this.getCustomerGridFormRows().at(index).enable();
        }
      });
    });
    this.addInlineEditTableComp.inlineTableSelection.clear();
    this.getIconsForCustomerServiceTableInfoMode(ModeIcons.add);
  }

  private customerServiceTableDataSelected(data: boolean) {
    if (this.isUfoCustomerServiceNotApplicable) {
      this.refreshCustomerServiceHeaderIcons();
      return;
    }
    const gridView = this.customerServiceGridPageMode === ModeIcons.view;
    const modifiedIcons = this.customerServiceTableHeaderIcons.map(
      (val: SvgIconProp) => {
        if (val.name === ActionIcons.delete || val.name === ActionIcons.edit) {
          val.isDisabled = !data;
        } else if (val.name === ActionIcons.save && !gridView) {
          if (data) {
            val.isDisabled = true;
          }
        } else if (val.name === ActionIcons.add) {
          const hasEditableRow = this.getCustomerGridFormRows()?.controls.some(control => !control.get('isRowDisable')?.value);
          val.isDisabled = data || hasEditableRow;
        } else if (val.name === ActionIcons.close) {
          if (data) {
            val.isDisabled = true;
          } else {
            const hasEditableRow = this.getCustomerGridFormRows()?.controls.some(control => !control.get('isRowDisable')?.value);
            val.isDisabled = gridView ? !hasEditableRow : false;
          }
        }
        return val;
      }
    );
    this.customerServiceTableHeaderIcons = modifiedIcons;
  }

  private getIconsForCustomerServiceTableInfoMode(mode: string) {
    const custServiceTableHeaderIcons = JSON.parse(
      JSON.stringify(DefaultInfoTableHeaderIcons)
    );
    const filtered: SvgIconProp[] = [];
    if (mode === ModeIcons.add || mode === ModeIcons.edit) {
      custServiceTableHeaderIcons.forEach((val: SvgIconProp) => {
        if (val.name !== ActionIcons.add && val.name !== ActionIcons.view) {
          filtered.push(val);
        }
      });
    } else if (mode === ModeIcons.view) {
      custServiceTableHeaderIcons.forEach((val: SvgIconProp) => {
        if (val.name === ActionIcons.add) {
          val.isDisabled = false;
        } else if (
          val.name === ActionIcons.edit ||
          val.name === ActionIcons.delete ||
          val.name === ActionIcons.save ||
          val.name === ActionIcons.close
        ) {
          val.isDisabled = true;
        }
        if (val.name !== ActionIcons.view) {
          filtered.push(val);
        }
      });
    }
    this.customerServiceTableHeaderIcons = filtered;
  }

  private refreshCustomerServiceHeaderIcons(): void {
    this.getIconsForCustomerServiceTableInfoMode(this.customerServiceGridPageMode);
    if (this.isUfoCustomerServiceNotApplicable) {
      this.customerServiceTableHeaderIcons =
        this.customerServiceTableHeaderIcons.map(icon => ({
          ...icon,
          isDisabled: true,
        }));
    }
  }

  private createForm() {
    const { form, errorMessages } = this.formUtilsService.generateForm(
      governmentInformationFields
    , this.destroyRef);
    this.accountGovtInfoForm = form;
    this.errorMessages = errorMessages;
    // Set default value for invoice file format
    this.accountGovtInfoForm.patchValue({
      invoiceFileFormat: this.selectedFileFormatType,
      billingType: ['2'],
      serviceTypes: getGovernmentServiceTypesTbdValue(),
      deliveryAgentId: GOVERNMENT_INFO_TBD_DISPLAY,
    });
  }

  public isServiceTypeShowingTbd(): boolean {
    return this.isServiceTypeTbd();
  }

  public onServiceTypeSelectionChange(): void {
    const control = this.accountGovtInfoForm.get('serviceTypes');
    const value = control?.value;
    if (!Array.isArray(value)) {
      this.dispatchBusinessFormChanges();
      return;
    }

    const actualSelections = value.filter(
      (item: string) => item !== GOVERNMENT_INFO_TBD_DISPLAY
    );

    if (!actualSelections.length) {
      if (!value.includes(GOVERNMENT_INFO_TBD_DISPLAY)) {
        control?.setValue(getGovernmentServiceTypesTbdValue(), {
          emitEvent: false,
        });
      }
    } else if (value.includes(GOVERNMENT_INFO_TBD_DISPLAY)) {
      control?.setValue(actualSelections, { emitEvent: false });
    }

    this.dispatchBusinessFormChanges();
  }

  public getServiceTypeTriggerLabel(): string {
    const selected = this.accountGovtInfoForm.get('serviceTypes')?.value;
    if (isGovernmentServiceTypeTbd(selected)) {
      return GOVERNMENT_INFO_TBD_DISPLAY;
    }

    return selected
      .map((id: string) => {
        const match = this.serviceTypeDropDownValues?.find(
          option => String(option.id) === String(id)
        );
        return match?.name ?? id;
      })
      .join(', ');
  }

  private isServiceTypeTbd(): boolean {
    return isGovernmentServiceTypeTbd(
      this.accountGovtInfoForm.get('serviceTypes')?.value
    );
  }

  private isDeliveryAgentTbd(): boolean {
    const display = (this.accountGovtInfoForm.get('deliveryAgentId')?.value ?? '')
      .toString()
      .trim();
    if (display.toUpperCase() === GOVERNMENT_INFO_TBD_DISPLAY) {
      return true;
    }
    const id = this.getAutocompleteIdValue('deliveryAgentId');
    return !id || id === 0;
  }

  private resolveServiceTypesForDispatch(): string[] | null {
    return this.isServiceTypeTbd()
      ? null
      : this.accountGovtInfoForm.get('serviceTypes')?.value || [];
  }

  private resolveDeliveryAgentIdForDispatch(): number | null {
    return this.isDeliveryAgentTbd()
      ? null
      : this.getAutocompleteIdValue('deliveryAgentId') || null;
  }

  private getSavedCustomerServiceRowCount(): number {
    const gridData =
      this.addInlineEditTableComp?.inlineCrudTableDataSource?.data ??
      this.governmentInfoTabFormData?.customerService;
    return getSavedCustomerServiceCount(gridData);
  }

  private applyGovernmentInfoTbdDefaults(): void {
    if (this.isServiceTypeTbd()) {
      this.accountGovtInfoForm
        .get('serviceTypes')
        ?.setValue(getGovernmentServiceTypesTbdValue(), { emitEvent: false });
    }
    if (this.isDeliveryAgentTbd()) {
      this.accountGovtInfoForm
        .get('deliveryAgentId')
        ?.setValue(GOVERNMENT_INFO_TBD_DISPLAY, { emitEvent: false });
      this.autocompleteSelectedIds.delete('deliveryAgentId');
    }
  }

  public addForInvoiceEmail(event: MatChipInputEvent): void {
    this.addValidatedEmailChip(
      event,
      this.emailCtrl,
      'emailCtrl',
      this.emailInput,
      this.emailsForInvoiceNotifications,
      'selectEmailsForInvoiceNotification'
    );
  }

  public addForGatewayEmail(event: MatChipInputEvent): void {
    this.addValidatedEmailChip(
      event,
      this.emailCtrl2,
      'emailCtrl2',
      this.emailInput2,
      this.emailsForGatewayNotifications,
      'selectEmailsforGatewayNotification'
    );
  }

  private addValidatedEmailChip(
    event: MatChipInputEvent,
    emailControl: FormControl,
    tooltipKey: string,
    inputRef: ElementRef<HTMLInputElement>,
    emails: string[],
    formControlName: string
  ): void {
    const value = (event.value || '').trim();
    if (!value) {
      event.input && (event.input.value = '');
      emailControl.setValue(null);
      this.commonService.closeErrorTooltip(
        tooltipKey,
        this.setGovernmentInfoErrorTooltip
      );
      return;
    }
    emailControl.setValue(value);
    emailControl.markAsTouched();
    if (emailControl.invalid) {
      this.showEmailChipErrorTooltip(tooltipKey, inputRef);
      return;
    }
    this.commonService.closeErrorTooltip(
      tooltipKey,
      this.setGovernmentInfoErrorTooltip
    );
    emails.push(value);
    event.input && (event.input.value = '');
    emailControl.setValue(null);
    this.accountGovtInfoForm.patchValue({ [formControlName]: emails });
    this.dispatchBusinessFormChanges();
  }

  private showEmailChipErrorTooltip(
    tooltipKey: string,
    inputRef: ElementRef<HTMLInputElement>
  ): void {
    const formField = inputRef.nativeElement.closest(
      'mat-form-field'
    ) as HTMLElement | null;
    if (formField) {
      this.setGovernmentInfoWidth[tooltipKey] = `${formField.offsetWidth}px`;
    }
    this.setGovernmentInfoErrorTooltip[tooltipKey] = true;
    this.cdr.detectChanges();
  }

  public onBillingTypeSelectionChange(event: any): void {
    this.dispatchBusinessFormChanges();
  }

  public isBillingOptionDisabled(optionId: string): boolean {
    if (!this.isAccountHasARInvoice || this.pageMode === ModeIcons.view) {
      return false;
    }
    return this.originalBillingTypeValues.includes(optionId);
  }

  removeForInvoiceEmail(email: any): void {
    const index = this.emailsForInvoiceNotifications.indexOf(email);
    if (index >= 0) {
      this.emailsForInvoiceNotifications.splice(index, 1);
    }
    this.filterInvoiceEmailDropdown();
    this.accountGovtInfoForm.patchValue({
      selectEmailsForInvoiceNotification: this.emailsForInvoiceNotifications,
    });
    this.dispatchBusinessFormChanges();
  }

  removeForGatewayEmail(email: any): void {
    const index = this.emailsForGatewayNotifications.indexOf(email);
    if (index >= 0) {
      this.emailsForGatewayNotifications.splice(index, 1);
    }
    this.filterGatewayEmailDropdown();
    this.accountGovtInfoForm.patchValue({
      selectEmailsforGatewayNotification: this.emailsForGatewayNotifications,
    });
    this.dispatchBusinessFormChanges();
  }

  selectedForInvoiceEmail(event: MatAutocompleteSelectedEvent): void {
    this.emailsForInvoiceNotifications.push(event.option.viewValue);
    this.emailInput.nativeElement.value = '';
    this.emailCtrl.setValue(null);
    this.filterInvoiceEmailDropdown();
    this.accountGovtInfoForm.patchValue({
      selectEmailsForInvoiceNotification: this.emailsForInvoiceNotifications,
    });
    this.dispatchBusinessFormChanges();
  }

  selectedForGatewayEmail(event: MatAutocompleteSelectedEvent): void {
    this.emailsForGatewayNotifications.push(event.option.viewValue);
    this.emailInput2.nativeElement.value = '';
    this.emailCtrl2.setValue(null);
    this.filterGatewayEmailDropdown();
    this.accountGovtInfoForm.patchValue({
      selectEmailsforGatewayNotification: this.emailsForGatewayNotifications,
    });
    this.dispatchBusinessFormChanges();
  }

  private filterInvoiceEmailDropdown() {
    this.filterUserInvoiceEmailData = this.filterUserInvoiceEmailData.pipe(
      map((data: any[]) =>
        data.filter(
          record => !this.emailsForInvoiceNotifications.includes(record.name)
        )
      )
    );
  }

  private filterGatewayEmailDropdown() {
    this.filterUserGatewayEmailData = this.filterUserGatewayEmailData.pipe(
      map((data: any[]) =>
        data.filter(
          record => !this.emailsForGatewayNotifications.includes(record.name)
        )
      )
    );
  }

  private async loadLookUpData() {
    const [
      userEmailData,
      salesPersonData,
      weightMetricData,
      clearanceTypeData,
      ibcChargeCodeData,
      serviceTypes,
      deliveryAgentData
    ]: any = await Promise.all([
      this.getMasterLookups(MasterLookup.userEmail),
      this.getMasterLookups(MasterLookup.salesPerson),
      this.getMasterLookups(MasterLookup.weightMetric),
      this.getMasterLookups(MasterLookup.clearanceType),
      this.getMasterLookups(MasterLookup.ibcChargeCode),
      this.getMasterLookups(MasterLookup.serviceType),
      this.getMasterLookups(MasterLookup.deliveryAgent
      ),
    ]);

    const governmentInfoState = this.store.selectSnapshot(
      state => state.accountsGovernmentInfo
    );
    const deliveryAgents = governmentInfoState?.deliveryAgentsLookup || [];
    const billingTypeData = governmentInfoState?.billingTypeLookup || [];
    const invoiceFileFormatData =
      governmentInfoState?.invoiceFileFormatLookup || [];
    const invoiceTypeData = governmentInfoState?.invoiceTypeLookup || [];

    const userEmail = this.ibcAuthService.getTokenInfo()?.username;
    if (userEmail) {
      const filterUsersData = userEmailData.filter(
        (item: any) => item.name !== userEmail
      );
      this.userInvoiceEmailData = filterUsersData;
      this.userGatewayEmailData = filterUsersData;
    } else {
      this.userInvoiceEmailData = userEmailData;
      this.userGatewayEmailData = userEmailData;
    }

    this.filterUserInvoiceEmailData = this.autocompleteValueChanges(
      MasterLookup.selectEmailsForInvoiceNotification,
      this.userInvoiceEmailData
    );

    this.filterUserGatewayEmailData = this.autocompleteValueChanges(
      MasterLookup.selectEmailsforGatewayNotification,
      this.userGatewayEmailData
    );
    this.salesPersonData = salesPersonData;
    this.filterSalesPersonOption = this.autocompleteValueChanges(
      MasterLookup.salesPerson,
      this.salesPersonData
    );
    this.billingTypeData = this.capitalizeDropdownOptions(billingTypeData);
    this.invoiceTypeDropdownValues = invoiceFileFormatData;
    this.invoiceTypeLookupData = invoiceTypeData;
    this.weightMetricDropdownValues =
      this.capitalizeWeightMetricOptions(weightMetricData);
    this.clearanceTypeDropdownValues = clearanceTypeData;
    this.ibcChargeCodeDropdownValues = ibcChargeCodeData;
    this.serviceTypeDropDownValues = serviceTypes;
    this.serviceTypeSearchCtrl.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(value => {
        this.serviceTypeSearchText = (value ?? '')
          .toString()
          .trim()
          .toLowerCase();
      });
    this.agentsDropDownValues = deliveryAgents;
    this.deliveryAgentData = deliveryAgentData;
    this.applyGovernmentInfoTbdDefaults();
    this.addAutocompleteValidators();
    this.filteredDeliveryAgentsList = this.accountGovtInfoForm
      .get('deliveryAgentId')!
      .valueChanges.pipe(
        startWith(''),
        map(value => {
          const filterValue =
            typeof value === 'string' ? value.toLowerCase() : '';

          return this.deliveryAgentData.filter(
            agent =>
              agent.code?.toUpperCase() !== GOVERNMENT_INFO_TBD_DISPLAY &&
              (agent.code?.toLowerCase().includes(filterValue) ||
                agent.description?.toLowerCase().includes(filterValue))
          );
        })
      );
    // Initialize autocomplete options for all relevant controls
    this.initializeAllAutocompleteOptions();

    // Mark lookup data as loaded
    this.isLookupDataLoaded = true;

    this.patchAllDropdownValuesData(this.governmentInfoTabFormData);

    // Re-patch autocomplete values if form data is already available
    if (this.governmentInfoTabFormData?.masterShipmentBilling) {
      // Small delay to ensure form controls are ready
      setTimeout(() => {
        this.patchAutocompleteValuesFromFormData(
          this.governmentInfoTabFormData.masterShipmentBilling
        );
      }, 0);
    }
  }

  private capitalizeDropdownOptions(
    dropdownData: IDropdownResponse[]
  ): IDropdownResponse[] {
    return dropdownData.map(option => ({
      ...option,
      name: option.name ? this.capitalizeFirstLetter(option.name) : option.name,
    }));
  }

  private capitalizeWeightMetricOptions(
    weightMetricData: IDropdownResponse[]
  ): IDropdownResponse[] {
    return this.capitalizeDropdownOptions(weightMetricData);
  }

  private capitalizeFirstLetter(text: string): string {
    if (!text) return text;
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  }

  private getMasterLookups(requestType: string) {
    return new Promise((resolve, reject) => {
      try {
        const lookup$ =
          requestType === MasterLookup.billingType ||
          requestType === MasterLookup.invoiceFileFormat ||
          requestType === MasterLookup.weightMetric
            ? this.commonService.getMasterLookups(requestType)
            : this.commonService.getMasterLookUp(requestType);

        lookup$
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe((response: ILookupDropdownResponse) => {
            resolve(response.data ?? []);
          });
      } catch (error) {
        reject(new Error(''));
      }
    });
  }

  public onTypeSelected(selectedType: any, dropdownData: any, control: string) {
    const selectedDataType = dropdownData.find(
      (type: IDropdownResponse) => type.name === selectedType
    );
    if (selectedDataType) {
      this.accountGovtInfoForm.get(control)?.setValue(selectedDataType.id);
      this.dispatchBusinessFormChanges();
    }
  }

  public onSalesPersonInput(): void {
    this.handleAutocompleteFieldInput(
      'salesPerson', 'name', this.salesPersonData,
      (id) => this.accountGovtInfoForm.get('salesPersonId')?.setValue(id),
      () => this.accountGovtInfoForm.get('salesPersonId')?.setValue(null)
    );
  }

  public onSalesPersonBlur(): void {
    this.handleAutocompleteFieldBlur(
      'salesPerson', 'name', ['name'], this.salesPersonData,
      (id) => this.accountGovtInfoForm.get('salesPersonId')?.setValue(id),
      () => this.accountGovtInfoForm.get('salesPersonId')?.setValue(null)
    );
  }

  public formAutocompleteValueChanges(
    controlName: string,
    apiControlName: string,
    dropdownResponse: any,
    formControlId?: string
  ) {
    this.commonService.getAutocompleteDropdownId(
      dropdownResponse,
      this.accountGovtInfoForm,
      controlName,
      apiControlName,
      false,
      formControlId
    );
  }

  private addAutocompleteValidators(): void {
    const salesPersonControl = this.accountGovtInfoForm.get('salesPerson');
    salesPersonControl?.addValidators(this.createAutocompleteValidator(
      () => this.salesPersonData, 'name'
    ));
    salesPersonControl?.updateValueAndValidity({ emitEvent: false });

    const deliveryAgentControl = this.accountGovtInfoForm.get('deliveryAgentId');
    deliveryAgentControl?.addValidators(this.createDeliveryAgentValidator());
    deliveryAgentControl?.updateValueAndValidity({ emitEvent: false });
  }

  private createDeliveryAgentValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = (control.value || '').toString().trim();
      if (
        !value ||
        value.toUpperCase() === GOVERNMENT_INFO_TBD_DISPLAY
      ) {
        return null;
      }
      const data = this.deliveryAgentData;
      if (!data?.length) {
        return null;
      }
      const match = data.find(
        (item: IDropdownResponse) =>
          item.code?.toLowerCase() === value.toLowerCase()
      );
      return match ? null : { autocompleteError: true };
    };
  }

  private createAutocompleteValidator(
    dataFn: () => IDropdownResponse[],
    matchField: string
  ): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = (control.value || '').toString().trim();
      if (!value) return null;
      const data = dataFn();
      if (!data?.length) return null;
      const match = data.find(
        (item: any) => item[matchField]?.toLowerCase() === value.toLowerCase()
      );
      return match ? null : { autocompleteError: true };
    };
  }

  private autocompleteValueChanges(
    controlName: string,
    dropdownData: IDropdownResponse[]
  ): Observable<IDropdownResponse[]> {
    const formControl = this.accountGovtInfoForm.get(
      controlName
    ) as FormControl;
    return formControl.valueChanges.pipe(
      startWith(''),
      map(val => {
        const filterValue =
          typeof val === DataTypes.String ? val.toLowerCase() : '';
        return dropdownData?.filter(
          item => item.name?.toLowerCase().includes(filterValue)
        );
      })
    );
  }

  private checkMode() {
    this.commonService.isCheckForMode
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: any) => {
        if (data === ModeIcons.view) {
          this.pageMode = ModeIcons.view;
          this.accountGovtInfoForm.disable();
          this.disableMasterBillingForms();
        } else {
          this.pageMode = data != '' ? data : ModeIcons.add;
          this.accountGovtInfoForm.enable();
          this.enableMasterBillingForms();
        }
        this.refreshCustomerServiceHeaderIcons();
        if (
          this.customerServiceGridPageMode !== ModeIcons.view &&
          this.customerServiceSelectedRow?.length > 0
        ) {
          this.customerServiceTableDataSelected(true);
        }
        this.applyGovernmentUfoFieldLocks();
      });
  }

  private applyGovernmentUfoFieldLocks(): void {
    if (!this.accountGovtInfoForm || this.pageMode === ModeIcons.view) {
      return;
    }
    const billingTypeControl = this.accountGovtInfoForm.get('billingType');
    if (this.commonService.isUFOAccountRestrictedEdit.value) {
      billingTypeControl?.disable({ emitEvent: false });
    } else {
      billingTypeControl?.enable({ emitEvent: false });
    }
  }

  private dataFetch() {
    this.commonService.savedBagData
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: any) => {
        if (data === pageType.dataBind) {
          this.fetchGovernmentInfoTabData();
        }
      });
  }

  private fetchGovernmentInfoTabData() {
    this.governmentInfoTabData$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(governmentInfoData => {
        this.governmentInfoTabFormData = governmentInfoData;
        this.accountGovtInfoForm.patchValue(this.governmentInfoTabFormData);

        if (governmentInfoData.isAccountHasARInvoice !== undefined) {
          this.isAccountHasARInvoice = governmentInfoData.isAccountHasARInvoice;
        }
        if (
          this.isAccountHasARInvoice &&
          governmentInfoData.originalBillingType &&
          Array.isArray(governmentInfoData.originalBillingType)
        ) {
          this.originalBillingTypeValues = governmentInfoData.originalBillingType.map(
            String
          );
        } else if (!this.isAccountHasARInvoice) {
          this.originalBillingTypeValues = [];
        }
        this.patchAllDropdownValuesData(this.governmentInfoTabFormData);

        this.emailsForInvoiceNotifications =
          this.governmentInfoTabFormData.selectEmailsForInvoiceNotification;
        this.emailsForGatewayNotifications =
          this.governmentInfoTabFormData.selectEmailsforGatewayNotification;

        // Patch master billing form data to retain values when switching tabs
        if (this.governmentInfoTabFormData.masterShipmentBilling) {
          this.patchMasterBillingForms(
            this.governmentInfoTabFormData.masterShipmentBilling ||
            this.governmentInfoTabFormData.masterShipmentBilling[0]
          );

          // Patch autocomplete values if lookup data is already loaded
          if (this.isLookupDataLoaded) {
            // Small delay to ensure form controls are ready
            setTimeout(() => {
              this.patchAutocompleteValuesFromFormData(
                this.governmentInfoTabFormData.masterShipmentBilling
              );
            }, 0);
          }
        }

        if (this.customerServiceGridForm) {
          this.clearAndPatchFormArray();
        }
        this.areEmailsSame();
      });
  }

  private bindCustomerGridData() {
    const rowsLength = JSON.parse(
      JSON.stringify(this.getCustomerGridFormRows().length)
    );
    const customerServiceDataLength = JSON.parse(
      JSON.stringify(this.governmentInfoTabFormData.customerService.length)
    );
    const condition =
      this.isAddClicked &&
        !this.governmentInfoTabFormData.customerService.filter(
          (customer: ICustomerService) => !customer.isRowDisable
        ).length
        ? customerServiceDataLength
        : customerServiceDataLength - rowsLength;
    for (let i = 0; i < condition; i++) {
      this.addInlineEditTableComp.addNewRow();
      this.addInlineEditTableComp.loadAutocompleteForNewRow(i + 1);
    }
  }

  private patchDataAfterBind() {
    const customerServiceData =
      this.isAddClicked &&
        !this.governmentInfoTabFormData.customerService.filter(
          (customer: ICustomerService) => !customer.isRowDisable
        ).length
        ? [
          ...defaultCustomerServiceData,
          ...this.governmentInfoTabFormData.customerService,
        ]
        : this.governmentInfoTabFormData.customerService;
    this.getCustomerGridFormRows().patchValue(customerServiceData);
    this.getCustomerGridFormRows().disable();
    if (this.isAddClicked || this.customerServiceGridPageMode !== ModeIcons.view) {
      this.getCustomerGridFormRows().at(0).enable();
    }
    this.addInlineEditTableComp.getTableData();
  }

  private resetFirstInputRow() {
    this.getCustomerGridFormRows().at(0).reset();
    this.getCustomerGridFormRows()
      .at(0)
      .patchValue(defaultCustomerServiceData[0]);
    this.getCustomerGridFormRows().at(0).markAsUntouched();
    this.getCustomerGridFormRows().at(0).updateValueAndValidity();
    this.addInlineEditTableComp.getTableData();
  }

  private clearAndPatchFormArray() {
    this.getCustomerGridFormRows().clear();
    this.addInlineEditTableComp.addNewRow();
    this.addInlineEditTableComp.loadAutocompleteForNewRow(0);
    this.bindCustomerGridData();
    this.patchDataAfterBind();
  }

  private getCustomerGridFormRows() {
    return this.customerServiceGridForm.get('rows') as FormArray;
  }

  private patchAllDropdownValuesData(formData: any) {
    if (!formData) return;

    // Patch Sales Person
    if (formData.salesPersonId && this.salesPersonData?.length) {
      const salesPersonObject = this.salesPersonData.find(
        (item: IDropdownResponse) => item.id === formData.salesPersonId
      );
      this.accountGovtInfoForm
        .get('salesPerson')
        ?.setValue(salesPersonObject ? salesPersonObject.name : '');
    }

    // Patch Invoice File Format - use the value from formData or default to 10
    const invoiceFileFormatValue =
      formData.invoiceFileFormat || this.selectedFileFormatType;
    this.accountGovtInfoForm
      .get('invoiceFileFormat')
      ?.setValue(invoiceFileFormatValue);

    this.accountGovtInfoForm
      .get('invoiceType')
      ?.setValue(formData.invoiceType ?? null);

    // Patch Billing Type
    if (formData.billingType && Array.isArray(formData.billingType)) {
      this.accountGovtInfoForm
        .get('billingType')
        ?.setValue(formData.billingType.map((item: number) => String(item)));
    }

    // Patch Service Types (API returns strings like ["HM", "IE"])
    if (
      formData.serviceTypes &&
      Array.isArray(formData.serviceTypes) &&
      formData.serviceTypes.length
    ) {
      this.accountGovtInfoForm
        .get('serviceTypes')
        ?.setValue(formData.serviceTypes);
    } else {
      this.accountGovtInfoForm
        .get('serviceTypes')
        ?.setValue(getGovernmentServiceTypesTbdValue());
    }

    if (formData.deliveryAgentId && formData.deliveryAgentId !== 0 && this.deliveryAgentData?.length) {
      const agent = this.deliveryAgentData.find(
        (a: IDropdownResponse) => a.id === formData.deliveryAgentId
      );
      this.accountGovtInfoForm
        .get('deliveryAgentId')
        ?.setValue(agent ? agent.code : '');
      this.autocompleteSelectedIds.set('deliveryAgentId', formData.deliveryAgentId);
    } else {
      this.accountGovtInfoForm
        .get('deliveryAgentId')
        ?.setValue(GOVERNMENT_INFO_TBD_DISPLAY);
      this.autocompleteSelectedIds.delete('deliveryAgentId');
    }
  }

  private checkGovtInfoValidData() {
    this.accountsService.isCheckForGovernmentInfoData
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data === true) {
          this.commonService.validateFormFields(this.accountGovtInfoForm);
          if (
            !this.isDeliveryAgentTbd() &&
            this.getSavedCustomerServiceRowCount() < 1
          ) {
            this.getCustomerGridFormRows().markAllAsTouched();
            this.addInlineEditTableComp.inlineCrudTableForm.updateValueAndValidity();
            this.cdr.detectChanges();
          }
          this.validateGovernmentInfoTab();
        } else {
          this.accountGovtInfoForm.markAsPristine();
          this.cdr.detectChanges();
        }
      });
  }

  public onSameAsInvoiceEmailChange(event: any) {
    if (event.checked) {
      this.emailsForGatewayNotifications = [
        ...this.emailsForInvoiceNotifications,
      ];
    } else {
      this.emailsForGatewayNotifications = [];
    }
    this.accountGovtInfoForm.patchValue({
      selectEmailsforGatewayNotification: this.emailsForGatewayNotifications,
    });
    this.dispatchBusinessFormChanges();
  }

  public areEmailsSame(): boolean {
    if (
      !this.emailsForGatewayNotifications?.length ||
      !this.emailsForInvoiceNotifications?.length
    ) {
      return false;
    }
    const setInvoice = new Set(this.emailsForInvoiceNotifications);
    const setGateway = new Set(this.emailsForGatewayNotifications);
    if (setInvoice.size !== setGateway.size) {
      return false;
    }
    for (const email of setInvoice) {
      if (!setGateway.has(email)) {
        return false;
      }
    }
    return true;
  }

  public mapTileToForm(tileHeader: string): FormGroup {
    const mapTileToForm: Record<string, FormGroup> = {
      Recovery: this.recoveryForm,
      'Reimbursable Charges': this.reimbursableChargesForm,
      ISC: this.iscForm,
      'Delivery Fees': this.delivertyFeesForm,
      'Clearance Charges': this.clearanceChargesForm,
    };
    if (tileHeader && mapTileToForm[tileHeader]) {
      return mapTileToForm[tileHeader];
    } else {
      return new FormGroup({});
    }
  }

  private validateGovernmentInfoTab() {
    const customerServiceOk =
      this.isDeliveryAgentTbd() || this.getSavedCustomerServiceRowCount() >= 1;

    if (this.accountGovtInfoForm.valid && customerServiceOk) {
      this.accountsService.checkGovernmentInfoDataValid(true);
    } else {
      this.accountsService.checkGovernmentInfoDataValid(false);
    }
    this.cdr.detectChanges();
  }

  private getDeletedCustomerServices() {
    this.accountsService.isDeletedCustomerServicesData
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(deletedCustomerService => {
        this.deletedCustomerServicesList = deletedCustomerService;
      });
  }

  private createRecoveryForm() {
    const { form } = this.formUtilsService.generateForm(recoveryFeesFormConfig, this.destroyRef);
    this.recoveryForm = form;
  }

  private createReimbursableChargesForm() {
    const { form } = this.formUtilsService.generateForm(
      reimbursableChargesFormConfig
    , this.destroyRef);
    this.reimbursableChargesForm = form;
  }

  private createIscForm() {
    const { form } = this.formUtilsService.generateForm(iscFormConfig, this.destroyRef);
    this.iscForm = form;
  }

  private createDeliveryFeesForm() {
    const { form } = this.formUtilsService.generateForm(deliveryFeesFormConfig, this.destroyRef);
    this.delivertyFeesForm = form;
  }

  private createClearanceChargesForm() {
    const { form } = this.formUtilsService.generateForm(
      clearanceChargesFormConfig
    , this.destroyRef);
    this.clearanceChargesForm = form;
  }

  private patchMasterBillingForms(masterBillingData: any) {
    const patchData = masterBillingData[0] || masterBillingData;
    if (this.recoveryForm) {
      this.recoveryForm.patchValue({
        recoveryAmount: patchData.recoveryAmount || '',
        recoveryWeightMetric: patchData.recoveryWeightMetric || 0,
      });
    }

    // Patch Reimbursable Charges Form
    if (this.reimbursableChargesForm) {
      this.reimbursableChargesForm.patchValue({
        reimbursableChargesClearanceType:
          patchData.reimbursableChargesClearanceType || '',
        reimbursableChargesValuePerShipment:
          patchData.reimbursableChargesValuePerShipment || '',
      });
    }

    // Patch ISC Form
    if (this.iscForm) {
      this.iscForm.patchValue({
        iscActualCost: patchData.iscActualCost || '',
        iscFlatFee: patchData.iscFlatFee || '',
      });
    }

    // Patch Delivery Fees Form
    if (this.delivertyFeesForm) {
      this.delivertyFeesForm.patchValue({
        deliveryAmount: patchData.deliveryAmount || '',
        deliveryWeightMetric: patchData.deliveryWeightMetric || 0,
      });
    }

    // Patch Clearance Charges Form
    if (this.clearanceChargesForm) {
      this.clearanceChargesForm.patchValue({
        clearanceChargesClearanceType:
          patchData.clearanceChargesClearanceType || '',
        clearanceChargesValuePerShipment:
          patchData.clearanceChargesValuePerShipment || '',
      });
    }
  }

  private disableMasterBillingForms() {
    if (this.recoveryForm) {
      this.recoveryForm.disable();
    }
    if (this.reimbursableChargesForm) {
      this.reimbursableChargesForm.disable();
    }
    if (this.iscForm) {
      this.iscForm.disable();
    }
    if (this.delivertyFeesForm) {
      this.delivertyFeesForm.disable();
    }
    if (this.clearanceChargesForm) {
      this.clearanceChargesForm.disable();
    }
  }
  private enableMasterBillingForms() {
    if (this.recoveryForm) {
      this.recoveryForm.enable();
    }
    if (this.reimbursableChargesForm) {
      this.reimbursableChargesForm.enable();
    }
    if (this.iscForm) {
      this.iscForm.enable();
    }
    if (this.delivertyFeesForm) {
      this.delivertyFeesForm.enable();
    }
    if (this.clearanceChargesForm) {
      this.clearanceChargesForm.enable();
    }
  }

  // Autocomplete functionality methods
  public onAutocompleteInput(controlName: string): void {
    const dropdownData = this.getAutocompleteDropdownData(controlName);
    if (dropdownData && dropdownData.length > 0) {
      const formGroup = this.mapTileToForm(
        this.getCurrentFormGroupForControl(controlName)
      );
      const inputValue = formGroup.get(controlName)?.value;

      // Check if the input matches any option
      const matchingOption = dropdownData.find(
        (option: IDropdownResponse) =>
          option.name?.toLowerCase() === inputValue?.toLowerCase()
      );

      if (matchingOption) {
        // Valid option selected - store the ID
        this.autocompleteSelectedIds.set(controlName, matchingOption.id);
        formGroup.get(controlName)?.setErrors(null);
      } else {
        // Invalid input - clear the stored ID and set error
        this.autocompleteSelectedIds.delete(controlName);
        if (inputValue && inputValue.trim() !== '') {
          formGroup.get(controlName)?.setErrors({ autocompleteError: true });
        }
      }
    }
  }

  public onAutocompleteOptionSelected(controlName: string, event: any): void {
    const selectedValue = event.option.value;
    const dropdownData = this.getAutocompleteDropdownData(controlName);

    if (dropdownData && dropdownData.length > 0) {
      const selectedOption = dropdownData.find(
        (option: IDropdownResponse) => option.name === selectedValue
      );
      if (selectedOption) {
        const formGroup = this.mapTileToForm(
          this.getCurrentFormGroupForControl(controlName)
        );

        // Store the ID for API payload
        this.autocompleteSelectedIds.set(controlName, selectedOption.id);

        // Set the display name in the form control (what user sees)
        formGroup
          .get(controlName)
          ?.setValue(selectedOption.name, { emitEvent: false });

        // Clear autocomplete errors
        formGroup.get(controlName)?.setErrors(null);

        // Dispatch form changes
        this.dispatchBusinessFormChanges();
      }
    }
  }

  public getFilteredAutocompleteOptions(
    controlName: string
  ): Observable<IDropdownResponse[]> {
    if (!this.autocompleteDataMap.has(controlName)) {
      this.initializeAutocompleteForControl(controlName);
    }
    return (
      this.autocompleteDataMap.get(controlName) || this.createEmptyObservable()
    );
  }

  private initializeAutocompleteForControl(controlName: string): void {
    const dropdownData = this.getAutocompleteDropdownData(controlName);
    if (dropdownData && dropdownData.length > 0) {
      const formGroup = this.mapTileToForm(
        this.getCurrentFormGroupForControl(controlName)
      );
      const formControl = formGroup.get(controlName) as FormControl;

      if (formControl) {
        const filteredOptions = formControl.valueChanges.pipe(
          startWith(''),
          map(val => {
            const filterValue =
              typeof val === DataTypes.String ? val.toLowerCase() : '';
            return dropdownData.filter(
              (option: IDropdownResponse) =>
                option.name?.toLowerCase().includes(filterValue)
            );
          })
        );

        this.autocompleteDataMap.set(controlName, filteredOptions);
      }
    }
  }

  private getAutocompleteDropdownData(
    controlName: string
  ): IDropdownResponse[] {
    // Map control names to their respective dropdown data - ONLY for autocomplete type fields
    const controlToDataMap: Record<string, IDropdownResponse[]> = {
      // Only IBC Charge Code fields are autocomplete type according to config
      recoveryIbcChargeCode: this.ibcChargeCodeDropdownValues,
      deliveryIbcChargeCode: this.ibcChargeCodeDropdownValues,
      reimbursableChargesIbcChargeCode: this.ibcChargeCodeDropdownValues,
      clearanceChargesIbcChargeCode: this.ibcChargeCodeDropdownValues,
      iscIbcChargeCode: this.ibcChargeCodeDropdownValues,
      reimbursableChargesClearanceType: this.clearanceTypeDropdownValues,
      clearanceChargesClearanceType: this.clearanceTypeDropdownValues,
    };

    return controlToDataMap[controlName] || [];
  }

  private getCurrentFormGroupForControl(controlName: string): string {
    // Map control names to their form group names - ONLY for autocomplete type fields
    const controlToFormGroupMap: Record<string, string> = {
      // Only IBC Charge Code fields are autocomplete type according to config
      recoveryIbcChargeCode: 'Recovery',
      deliveryIbcChargeCode: 'Delivery Fees',
      reimbursableChargesIbcChargeCode: 'Reimbursable Charges',
      clearanceChargesIbcChargeCode: 'Clearance Charges',
      iscIbcChargeCode: 'ISC',
      clearanceChargesClearanceType: 'Clearance Charges',
      reimbursableChargesClearanceType: 'Reimbursable Charges',
    };

    return controlToFormGroupMap[controlName] || 'Recovery';
  }

  private createEmptyObservable(): Observable<IDropdownResponse[]> {
    return new Observable(observer => {
      observer.next([]);
      observer.complete();
    });
  }

  private initializeAllAutocompleteOptions(): void {
    // Initialize autocomplete for only autocomplete type form controls (IBC Charge Code fields)
    const autocompleteControls = [
      'recoveryIbcChargeCode',
      'deliveryIbcChargeCode',
      'reimbursableChargesIbcChargeCode',
      'clearanceChargesIbcChargeCode',
      'iscIbcChargeCode',
      'reimbursableChargesClearanceType',
      'clearanceChargesClearanceType',
    ];

    autocompleteControls.forEach(controlName => {
      const dropdownDataValues = this.getAutocompleteDropdownData(controlName);
      if (dropdownDataValues && dropdownDataValues.length > 0) {
        const form = this.mapTileToForm(
          this.getCurrentFormGroupForControl(controlName)
        );
        const formFieldControl = form.get(controlName) as FormControl;

        if (formFieldControl) {
          const filteredOptions = formFieldControl.valueChanges.pipe(
            startWith(''),
            map(val => {
              const filteredValue =
                typeof val === DataTypes.String ? val.toLowerCase() : '';
              return dropdownDataValues.filter(
                (option: IDropdownResponse) =>
                  option.name?.toLowerCase().includes(filteredValue)
              );
            }),
            takeUntilDestroyed(this.destroyRef)
          );

          this.autocompleteDataMap.set(controlName, filteredOptions);
        }
      }
    });
  }

  private patchAutocompleteDisplayValue(
    controlName: string,
    selectedId: number
  ): void {
    if (!selectedId) return;

    const dropdownData = this.getAutocompleteDropdownData(controlName);
    if (dropdownData && dropdownData.length > 0) {
      const selectedOption = dropdownData.find(
        (option: IDropdownResponse) => option.id === selectedId
      );
      if (selectedOption) {
        const formGroup = this.mapTileToForm(
          this.getCurrentFormGroupForControl(controlName)
        );
        const formControl = formGroup.get(controlName);

        if (formControl) {
          // Store the ID for API payload
          this.autocompleteSelectedIds.set(controlName, selectedId);

          // Set the display name instead of the ID for autocomplete
          formControl.setValue(selectedOption.name, { emitEvent: false });
        }
      }
    }
  }

  private getAutocompleteIdValue(controlName: string): number {
    return this.autocompleteSelectedIds.get(controlName) || 0;
  }

  private patchAutocompleteValuesFromFormData(masterBillingData: any): void {
    const patchData = masterBillingData[0] || masterBillingData;

    // Only patch autocomplete fields (IBC Charge Code fields)
    const autocompleteFields = [
      {
        controlName: 'recoveryIbcChargeCode',
        value: patchData.recoveryIbcChargeCode,
      },
      {
        controlName: 'deliveryIbcChargeCode',
        value: patchData.deliveryIbcChargeCode,
      },
      {
        controlName: 'reimbursableChargesIbcChargeCode',
        value: patchData.reimbursableChargesIbcChargeCode,
      },
      {
        controlName: 'clearanceChargesIbcChargeCode',
        value: patchData.clearanceChargesIbcChargeCode,
      },
      { controlName: 'iscIbcChargeCode', value: patchData.iscIbcChargeCode },
      {
        controlName: 'reimbursableChargesClearanceType',
        value: patchData.reimbursableChargesClearanceType,
      },
      {
        controlName: 'clearanceChargesClearanceType',
        value: patchData.clearanceChargesClearanceType,
      },
    ];

    autocompleteFields.forEach(field => {
      if (field.value) {
        this.patchAutocompleteDisplayValue(field.controlName, field.value);
      }
    });
  }

  public onDeliveryAgentSelected(
    event: MatAutocompleteSelectedEvent,
    control: string
  ): void {
    const selectedCode = event.option.value;
    const selectedAgent = this.deliveryAgentData.find(
      agent => agent.code === selectedCode
    );
    if (!selectedAgent) return;
    this.accountGovtInfoForm
      .get(control)
      ?.setValue(selectedAgent.code, { emitEvent: false });

    this.autocompleteSelectedIds.set(control, selectedAgent.id);
    this.dispatchBusinessFormChanges();
  }

  public onDeliveryAgentInput(): void {
    const control = this.accountGovtInfoForm.get('deliveryAgentId');
    const inputValue = (control?.value || '').toString().trim();
    if (inputValue.toUpperCase() === GOVERNMENT_INFO_TBD_DISPLAY) {
      this.autocompleteSelectedIds.delete('deliveryAgentId');
      control?.markAsTouched();
      control?.updateValueAndValidity({ emitEvent: false });
      return;
    }
    const exactMatch = this.deliveryAgentData?.find(
      agent => agent.code?.toLowerCase() === inputValue.toLowerCase()
    );
    control?.markAsTouched();
    control?.updateValueAndValidity({ emitEvent: false });
    if (exactMatch) {
      this.autocompleteSelectedIds.set('deliveryAgentId', exactMatch.id);
      return;
    }
    this.autocompleteSelectedIds.delete('deliveryAgentId');
  }

  public onDeliveryAgentBlur(): void {
    this.handleAutocompleteFieldBlur(
      'deliveryAgentId', 'code', ['code', 'description'], this.deliveryAgentData,
      (id) => this.autocompleteSelectedIds.set('deliveryAgentId', id),
      () => this.autocompleteSelectedIds.delete('deliveryAgentId')
    );
  }

  public onServiceTypeDropdownOpened(isOpened: boolean): void {
    if (!isOpened) {
      this.serviceTypeSearchCtrl.setValue('', { emitEvent: false });
      this.serviceTypeSearchText = '';
      return;
    }

    this.serviceTypeSearchCtrl.setValue('');
    setTimeout(() => this.serviceTypeSearchInput?.nativeElement?.focus());
  }

  public isServiceTypeTbdOptionVisible(): boolean {
    if (!this.serviceTypeSearchText) {
      return true;
    }

    return GOVERNMENT_INFO_TBD_DISPLAY
      .toLowerCase()
      .includes(this.serviceTypeSearchText);
  }

  public isServiceTypeOptionVisible(option: IDropdownResponse): boolean {
    if (!this.serviceTypeSearchText) {
      return true;
    }

    const searchableValues = [
      option.name,
      option.code,
      option.description,
      option.id?.toString(),
    ];

    return searchableValues.some(value =>
      value?.toString().toLowerCase().includes(this.serviceTypeSearchText)
    );
  }

  public hasVisibleServiceTypeOptions(): boolean {
    return (
      this.isServiceTypeTbdOptionVisible() ||
      (this.serviceTypeDropDownValues ?? []).some(option =>
        this.isServiceTypeOptionVisible(option)
      )
    );
  }

  private handleAutocompleteFieldInput(
    controlName: string,
    displayField: string,
    data: IDropdownResponse[],
    setId: (id: number) => void,
    clearId: () => void
  ): void {
    const control = this.accountGovtInfoForm.get(controlName);
    const inputValue = (control?.value || '').toString().trim();
    const exactMatch = data?.find(
      (item: any) => item[displayField]?.toLowerCase() === inputValue.toLowerCase()
    );
    control?.markAsTouched();
    control?.updateValueAndValidity({ emitEvent: false });
    if (exactMatch) {
      setId(exactMatch.id);
    } else {
      clearId();
    }
    this.dispatchBusinessFormChanges();
  }

  private handleAutocompleteFieldBlur(
    controlName: string,
    displayField: string,
    filterFields: string[],
    data: IDropdownResponse[],
    setId: (id: number) => void,
    clearId: () => void
  ): void {
    if (this.autocompleteBlurTimer) {
      clearTimeout(this.autocompleteBlurTimer);
    }
    this.autocompleteBlurTimer = setTimeout(() => {
      const control = this.accountGovtInfoForm.get(controlName);
      const inputValue = (control?.value || '').toString().trim();

      if (!inputValue) {
        control?.setValue(GOVERNMENT_INFO_TBD_DISPLAY, { emitEvent: false });
        clearId();
        this.dispatchBusinessFormChanges();
        return;
      }

      const exactMatch = data?.find(
        (item: any) => item[displayField]?.toLowerCase() === inputValue.toLowerCase()
      );

      if (exactMatch) {
        setId(exactMatch.id);
        this.dispatchBusinessFormChanges();
        return;
      }

      const filteredOptions = data?.filter(
        (item: any) => filterFields.some(
          field => item[field]?.toLowerCase().includes(inputValue.toLowerCase())
        )
      );

      if (filteredOptions?.length === 1) {
        const match = filteredOptions[0];
        control?.setValue((match as any)[displayField], { emitEvent: false });
        setId(match.id);
        control?.updateValueAndValidity({ emitEvent: false });
      }

      this.dispatchBusinessFormChanges();
    }, 200);
  }
}
